
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './pages/Authentication/Login';
import ForgotPassword from './pages/Authentication/ForgotPassword';
import ResetPassword from './pages/Authentication/ResetPassword';
import ChooseCountry from './pages/Authentication/ChooseCountry';
import Registration from './pages/Authentication/Registration';
import Nofound404 from './pages/errorPages/Nofound404';
import OTP from './pages/Authentication/OTP';
import EmailOTP from './pages/Authentication/EmailOTP';


import ChooseUserType from './pages/Startup/ChooseUserType';
import PersonalDetails from './pages/Details/PersonalDetails';
import ProductAttributes from './pages/Details/ProductAttributes';
import ReOrderProdcutattributes from './pages/Details/ReOrderProductattributes';
import BulkUploadProduct from './pages/Details/BulkUploadProduct';
import Dashboard from './pages/Dashbaord/Dashboard';
import ViewCategories from './pages/Category/ViewCategories';
import AddCategory from './pages/Category/AddCategory';

// Products
import ViewProducts from './pages/Products/ViewProducts';
import AddProducts from './pages/Products/AddProducts';
// import ProductWizard from './pages/Products/ProductWizard';
import AddProductPriceList from './pages/Products/AddProductPriceList';
import ViewProductPriceList from './pages/Products/ViewProductPriceList';


// suppliers
import ViewSuppliers from './pages/suppliers/ViewSuppliers';
import AddSupplier from './pages/suppliers/AddSupplier';
import SuppliersProducts from './pages/suppliers/SuppliersProducts';

// Distributors
import ViewDistributors from './pages/Distributors/ViewDistributors';
import ViewBuyers from './pages/Distributors/ViewBuyers';
import ViewDistributorsRequest from './pages/Distributors/ViewDistributorsRequest';

// Orders
import ViewBuyerOrders from './pages/orders/ViewBuyerOrders';
import ViewSellerOrders from './pages/orders/ViewSellerOrders';
import OrderDetails from './pages/orders/OrderDetails';

// Users
import ViewUsers from './pages/Users/ViewUsers';
import AddUser from './pages/Users/AddUser';

//Plans
import Plans from './pages/plans/Plans';
import EditProduct from './pages/Products/EditProduct';
import ViewProductDetails from './pages/Products/ViewProductDetails';

//Reports
import Report from './pages/Reports/Reports';

//Settings
import Settings from './pages/Settings/Settings';
import GeneralSettings from './pages/Settings/GeneralSettings';
import EditProductAttributes from './pages/Settings/EditProductAttributes';
import Badges from './pages/Settings/Badges';
import Warehouse from './pages/Settings/Warehouse';

//Profile
import Profile from './pages/Profile/Profile';
import PrivacyPolicy from './pages/Leagal/PrivacyPolicy';
import Cart from './pages/plans/Cart';
import ToastCleaner from './Utils/ToastCleaner';


function App() {
  return (
    <BrowserRouter>
     <ToastCleaner />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/ForgotPassword/" element={<ForgotPassword />} />
        <Route path="/ResetPassword/:token/" element={<ResetPassword />} />
        <Route path="/ChooseCountry/" element={<ChooseCountry />} />
        <Route path="/Register/:country/" element={<Registration />} />
        <Route path="/Register/" element={<Nofound404 />} />
        <Route path="/OTP/" element={<OTP />} />
        <Route path="/EmailOTP/" element={<EmailOTP />} />

        <Route path="/UserType/" element={<ChooseUserType />} />

        <Route path="/Business-details/:type" element={<PersonalDetails />} />
        <Route path="/Product-Attributes/" element={<ProductAttributes />} />
        <Route path="/seller/Reorder-Product-Attributes/" element={<ReOrderProdcutattributes />} />
        <Route path="/seller/Bulk-Upload-Productsheet/" element={<BulkUploadProduct />} />
        <Route path="/Dashboard/:type" element={<Dashboard />} />

        {/* Categories */}
        <Route path="/:type/categories/Add-category" element={<AddCategory />} />
        <Route path="/:type/categories/View-categories/" element={<ViewCategories />} />
        {/* <Route path="/seller/add-sub-category/" element={<AddSubCategory />} /> */}

        {/* Products */}
        <Route path="/:type/products/View-all-products/" element={<ViewProducts />} />
        <Route path="/:type/products/Add-product/" element={<AddProducts />} />
        <Route path="/:type/products/edit-product/:id" element={<EditProduct />} />
        <Route path="/:type/products/view-product-details/:id" element={<ViewProductDetails />} />
        {/* <Route path="/products/ProductWizard" element={<ProductWizard />} /> */}
        <Route path="/:type/products/AddProductPriceList" element={<AddProductPriceList />} />
        <Route path="/:type/products/ProductPriceList" element={<ViewProductPriceList />} />

        {/* suppliers */}
        <Route path="/:type/suppliers/View-all-suppliers/" element={<ViewSuppliers />} />
        <Route path="/:type/suppliers/Add-supplier/" element={<AddSupplier />} />
        <Route path="/:type/suppliers/supplier-products/:supplierID" element={<SuppliersProducts />} />

        {/* Distributor */}
        {/* <Route path="/distributors/Add-distributor/" element={<AddSupplier />} /> */}
        <Route path="/:type/distributors/View-distributor/" element={<ViewDistributors />} />
        <Route path="/:type/distributors/View-distributors-request/" element={<ViewDistributorsRequest />} />
        <Route path="/:type/buyer/View-buyers/" element={<ViewBuyers />} />

        {/* Orders */}
        <Route path="/:type/orders/View-Buyer-orders/" element={<ViewBuyerOrders />} />
        <Route path="/:type/orders/Order-details/:id" element={<OrderDetails />} />
        <Route path="/:type/orders/View-Seller-orders/:orderType" element={<ViewSellerOrders />} />

        {/* Users */}
        <Route path="/:type/users/View-Users/" element={<ViewUsers />} />
        <Route path="/:type/users/Add-User/" element={<AddUser />} />

        {/* Plans */}
        <Route path="/:type/plans/" element={<Plans />} />
        <Route path="/:type/Cart/:cur/:id" element={<Cart />} />

        {/* Reports */}
        <Route path="/:type/reports/" element={<Report />} />

        {/* settings */}
        <Route path="/:type/settings/" element={<Settings />} />
        <Route path="/:type/GeneralSettings/" element={<GeneralSettings />} />
        <Route path="/:type/EditProductAttributes/" element={<EditProductAttributes />} />
        {/* <Route path="/:type/EditProductAttributes/" element={<EditProductAttributes />} /> */}
        <Route path="/:type/Badges/" element={<Badges />} />
        <Route path="/:type/Warehouse/" element={<Warehouse />} />

        {/* Profile */}
        <Route path="/:type/profile/" element={<Profile />} />

        {/* Legal */}
        <Route path="/legal/cloud-terms-of-service" element={<Profile />} />
        <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
